import NavigateEvent from "../../core/navigation/NavigateEvent";
import SkinFactory from "../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";

/**
* PlayVideoCommand.js
* 
* Created on Sep 26, 2013, 4:14:36 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class PlayVideoCommand {
    constructor(dispatcher, variableManager) {
        this._dispatcher = dispatcher;
        this._variableManager = variableManager;
    }

    execute({ params }) {

        this._variableManager.setVariable('dialog_show_complete_popup', false);

        // Create skin
        this._moviePlayerSkin = SkinFactory.getSkin(SkinKeyRegistry.VIDEO_PLAYER_SKIN);
        this._moviePlayerSkin.content = params.data.content;
        this._moviePlayerSkin.contentPlayer = params.data.contentPlayer;

        // Listen to content completed
        this._contentCompletedEventListener = this.handleContentCompleted.bind(this);
        this._moviePlayerSkin.contentPlayer.eventDispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._contentCompletedEventListener);

        // Open screen
        const commandEvent = new NavigateEvent(NavigateEvent.OPEN_SCREEN_REQUEST, null, this._moviePlayerSkin, null, false);
        this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });
    }

    destroy() {
        this._moviePlayerSkin.contentPlayer.eventDispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._contentCompletedEventListener);
        this._moviePlayerSkin.content = null;
        this._moviePlayerSkin.contentPlayer = null;
        this._moviePlayerSkin = null;
        this._contentCompletedEventListener = null;
        this._dispatcher = null;
    }

    handleContentCompleted({ params }) {
        if (params.data.content === this._moviePlayerSkin.content) {
            // Close screen
            const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._moviePlayerSkin);
            this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });

            this.destroy();
        }
    }
}